import type { Dispatch, SetStateAction } from "react"
import { createContext } from "react"

interface ICalendarLayoutContext {
  selectedDate?: Date
  setSelectedDate: Dispatch<SetStateAction<Date | undefined>>
}

export const CalendarLayoutContext = createContext<ICalendarLayoutContext>({
  selectedDate: undefined,
  setSelectedDate: () => {
    /* noop */
  },
})
